import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _851a3096 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _cdf49640 = () => interopDefault(import('..\\pages\\hub\\index.vue' /* webpackChunkName: "pages_hub_index" */))
const _2c0038f4 = () => interopDefault(import('..\\pages\\not-eligible.vue' /* webpackChunkName: "pages_not-eligible" */))
const _ff238a94 = () => interopDefault(import('..\\pages\\prescribing-information.vue' /* webpackChunkName: "pages_prescribing-information" */))
const _3eb2edda = () => interopDefault(import('..\\pages\\print.vue' /* webpackChunkName: "pages_print" */))
const _d0d7a058 = () => interopDefault(import('..\\pages\\safety-information.vue' /* webpackChunkName: "pages_safety-information" */))
const _64e86ef0 = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _1cfaaa92 = () => interopDefault(import('..\\pages\\tc.vue' /* webpackChunkName: "pages_tc" */))
const _5e9ec296 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _5eacda17 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _5ec90919 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _5ed7209a = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _d8f60452 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _1096e99b = () => interopDefault(import('..\\pages\\hub\\eligibility.vue' /* webpackChunkName: "pages_hub_eligibility" */))
const _161dfef2 = () => interopDefault(import('..\\pages\\hub\\patient-information.vue' /* webpackChunkName: "pages_hub_patient-information" */))
const _364ccfea = () => interopDefault(import('..\\pages\\patient\\eligibility.vue' /* webpackChunkName: "pages_patient_eligibility" */))
const _2c79853c = () => interopDefault(import('..\\pages\\patient\\patient-information.vue' /* webpackChunkName: "pages_patient_patient-information" */))
const _3e322ad0 = () => interopDefault(import('..\\pages\\specialty-pharmacy\\eligibility.vue' /* webpackChunkName: "pages_specialty-pharmacy_eligibility" */))
const _1e0fb2ef = () => interopDefault(import('..\\pages\\specialty-pharmacy\\patient-information.vue' /* webpackChunkName: "pages_specialty-pharmacy_patient-information" */))
const _79acc97f = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _851a3096,
    name: "error"
  }, {
    path: "/hub",
    component: _cdf49640,
    name: "hub"
  }, {
    path: "/not-eligible",
    component: _2c0038f4,
    name: "not-eligible"
  }, {
    path: "/prescribing-information",
    component: _ff238a94,
    name: "prescribing-information"
  }, {
    path: "/print",
    component: _3eb2edda,
    name: "print"
  }, {
    path: "/safety-information",
    component: _d0d7a058,
    name: "safety-information"
  }, {
    path: "/success",
    component: _64e86ef0,
    name: "success"
  }, {
    path: "/tc",
    component: _1cfaaa92,
    name: "tc"
  }, {
    path: "/errors/400",
    component: _5e9ec296,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _5eacda17,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _5ec90919,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _5ed7209a,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _d8f60452,
    name: "errors-500"
  }, {
    path: "/hub/eligibility",
    component: _1096e99b,
    name: "hub-eligibility"
  }, {
    path: "/hub/patient-information",
    component: _161dfef2,
    name: "hub-patient-information"
  }, {
    path: "/patient/eligibility",
    component: _364ccfea,
    name: "patient-eligibility"
  }, {
    path: "/patient/patient-information",
    component: _2c79853c,
    name: "patient-patient-information"
  }, {
    path: "/specialty-pharmacy/eligibility",
    component: _3e322ad0,
    name: "specialty-pharmacy-eligibility"
  }, {
    path: "/specialty-pharmacy/patient-information",
    component: _1e0fb2ef,
    name: "specialty-pharmacy-patient-information"
  }, {
    path: "/",
    component: _79acc97f,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
